import React, { Suspense, lazy, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const SharedBrandWorksPage = lazy(() => import('./brand-works'));
const SharedSurveyResultsPage = lazy(() => import('./survey-results'));
const SharedStockHoldPage = lazy(() => import('./stock-hold'));
const SharedAppleProgramPage = lazy(() => import('./apple-program'));

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

const Fallback = () => (
  <div
    style={{
      minHeight: '100vh',
      background: '#f1f5f9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div className="spinner-border text-primary" role="status" style={{ width: '48px', height: '48px' }} />
      <p style={{ color: '#64748b', marginTop: '16px' }}>Yükleniyor...</p>
    </div>
  </div>
);

/**
 * /share/:shareKey — linkin sayfa tipine göre ilgili public sayfayı yükler.
 * Sayfa tipi auth-info ucundan okunur; hata durumunda brand-works sayfası kendi hata ekranını gösterir.
 */
export default function SharedPageRouter() {
  const { shareKey } = useParams<{ shareKey: string }>();
  const [pageType, setPageType] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setPageType(null);
    axios
      .get(`${REACT_APP_API_URL}/share-links/public/${shareKey}/auth-info`)
      .then((res) => !cancelled && setPageType(res.data?.page_type || 'brand_works'))
      .catch(() => !cancelled && setPageType('brand_works'));
    return () => {
      cancelled = true;
    };
  }, [shareKey]);

  if (!pageType) return <Fallback />;

  return (
    <Suspense fallback={<Fallback />}>
      {pageType === 'survey_results' ? (
        <SharedSurveyResultsPage shareKey={shareKey} />
      ) : pageType === 'stock_hold' ? (
        <SharedStockHoldPage shareKey={shareKey} />
      ) : pageType === 'apple_program' ? (
        <SharedAppleProgramPage shareKey={shareKey} />
      ) : (
        <SharedBrandWorksPage shareKey={shareKey} />
      )}
    </Suspense>
  );
}
